var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0905 19.181C12.8369 19.181 14.4676 18.6128 15.7933 17.666L19.3062 21.1938C19.5376 21.4253 19.8427 21.541 20.1583 21.541C20.8422 21.541 21.3367 21.015 21.3367 20.3417C21.3367 20.026 21.2315 19.7315 21 19.5L17.5187 15.9932C18.5602 14.6255 19.181 12.9316 19.181 11.0905C19.181 6.64019 15.5408 3 11.0905 3C6.62967 3 3 6.64019 3 11.0905C3 15.5408 6.62967 19.181 11.0905 19.181ZM11.0905 17.4345C7.6081 17.4345 4.74645 14.5623 4.74645 11.0905C4.74645 7.61862 7.6081 4.74645 11.0905 4.74645C14.5623 4.74645 17.4345 7.61862 17.4345 11.0905C17.4345 14.5623 14.5623 17.4345 11.0905 17.4345Z",
    fill: "#64748B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.6e8b36de5ce9723b0d40a26ef9091299.svg";
export { ForwardRef as ReactComponent };